// test2539
(2539 && 0);
